import { jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';

function Footer({ children, className }) {
    return (jsx("tfoot", { className: cns('table__foot', className), children: children }));
}
Footer.defaultProps = {
    children: null,
    className: '',
};

export { Footer as default };
